import { getInitialState, getPath } from "../../utils";

const initialState = {
  campaignCities: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case "SET_CAMPAIGN_CITIES":
      return setCampaignCities(state, action);
    case "RESET_STATE_CAMPAIGN":
      return resetState(state, action);
    default:
      return state;
  }
}

const setCampaignCities = (state, action) => {
  return {
    ...state,
    campaignCities: getPath(action.payload, "mappings", []),
  };
};

const resetState = (state, action) => {
  return {
    ...state,
    [action.payload.state]: getInitialState(initialState, action.payload.state),
  };
};
